export enum eAuth0ClientType {
  /**
   * Legacy
   */
  Admin = 'admin',
  Company = 'company',
  Consumer = 'consumer',
  /**
   * New
   */
  AdminNew = 'Admin',
  Client = 'Client',
  Vendor = 'Vendor',
}
